'use client';
import React, { useState, useMemo } from 'react';
import Icon from '@/components/ui/AppIcon';
import AppImage from '@/components/ui/AppImage';

type Category = 'All' | 'Food' | 'Accessories' | 'Health' | 'Grooming' | 'Toys' | 'Adoption';

const allProducts = [
{
  id: 'prod-001',
  name: 'Royal Canin Adult Dog Food 8kg',
  category: 'Food' as Category,
  price: 2450,
  rating: 4.8,
  reviews: 312,
  seller: 'PetNutrition PH',
  verified: true,
  location: 'Makati City',
  image: "https://images.unsplash.com/photo-1598285375273-cb65e990aacd",
  imageAlt: 'Bag of dry dog food with orange packaging on white background',
  badge: null,
  sold: 1204
},
{
  id: 'prod-002',
  name: 'Leather Adjustable Dog Collar with NFC Tag Slot',
  category: 'Accessories' as Category,
  price: 850,
  rating: 4.9,
  reviews: 87,
  seller: 'TaggedPets PH',
  verified: true,
  location: 'BGC, Taguig',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_18a648523-1764727342103.png",
  imageAlt: 'Brown leather dog collar with metal hardware on wooden surface',
  badge: 'Top Rated',
  sold: 543
},
{
  id: 'prod-003',
  name: 'Nexgard Spectra Flea & Tick Chewables (3 pack)',
  category: 'Health' as Category,
  price: 1200,
  rating: 4.7,
  reviews: 195,
  seller: 'VetSupply PH',
  verified: true,
  location: 'Quezon City',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_17885376c-1772176210383.png",
  imageAlt: 'Veterinarian holding medication blister pack in clinic',
  badge: 'Bestseller',
  sold: 3210
},
{
  id: 'prod-004',
  name: 'Professional Dog Grooming Scissors Set',
  category: 'Grooming' as Category,
  price: 1890,
  rating: 4.6,
  reviews: 64,
  seller: 'Groom&Bloom',
  verified: false,
  location: 'Pasig City',
  image: "https://images.unsplash.com/photo-1662122233724-d2cd72f9f10b",
  imageAlt: 'Set of silver grooming scissors and combs on gray background',
  badge: null,
  sold: 210
},
{
  id: 'prod-005',
  name: 'Interactive Feather Wand Cat Toy',
  category: 'Toys' as Category,
  price: 320,
  rating: 4.5,
  reviews: 142,
  seller: 'KittyPlay PH',
  verified: true,
  location: 'Mandaluyong',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_16d8a2124-1773142966341.png",
  imageAlt: 'Orange cat playing with feather toy in living room',
  badge: null,
  sold: 987
},
{
  id: 'prod-006',
  name: 'Whiskas Wet Cat Food Mixed Variety 24-pack',
  category: 'Food' as Category,
  price: 980,
  rating: 4.4,
  reviews: 278,
  seller: 'PetNutrition PH',
  verified: true,
  location: 'Makati City',
  image: "https://images.unsplash.com/photo-1732178386232-3f2f79b50ec2",
  imageAlt: 'Cat eating wet food from bowl on kitchen floor',
  badge: null,
  sold: 4521
},
{
  id: 'prod-007',
  name: 'Luna — Shih Tzu, 3 months, Female',
  category: 'Adoption' as Category,
  price: 0,
  rating: 5.0,
  reviews: 12,
  seller: 'BACH Project PH',
  verified: true,
  location: 'Quezon City',
  image: "https://images.unsplash.com/photo-1610385874395-e75e493098b7",
  imageAlt: 'Shih Tzu puppy with white and brown fur looking at camera',
  badge: 'Adopt Free',
  sold: 0
},
{
  id: 'prod-008',
  name: 'Stainless Steel Pet Water Fountain 2.5L',
  category: 'Accessories' as Category,
  price: 1650,
  rating: 4.7,
  reviews: 93,
  seller: 'PetHome PH',
  verified: true,
  location: 'Paranaque',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1e65e7d8a-1773142969421.png",
  imageAlt: 'Silver pet water fountain with flowing water on white background',
  badge: 'New',
  sold: 341
},
{
  id: 'prod-009',
  name: 'Cat Calming Spray — Lavender Formula 120ml',
  category: 'Health' as Category,
  price: 450,
  rating: 4.3,
  reviews: 56,
  seller: 'VetSupply PH',
  verified: true,
  location: 'Quezon City',
  image: "https://images.unsplash.com/photo-1617182700213-1f4b9520066f",
  imageAlt: 'Small spray bottle with purple label on wooden table',
  badge: null,
  sold: 128
},
{
  id: 'prod-010',
  name: 'Buddy — Labrador Mix, 1 year, Male',
  category: 'Adoption' as Category,
  price: 0,
  rating: 4.9,
  reviews: 8,
  seller: 'BACH Project PH',
  verified: true,
  location: 'Pasig City',
  image: "https://images.unsplash.com/photo-1559045585-4fad8bcbb115",
  imageAlt: 'Yellow Labrador dog sitting outdoors with happy expression',
  badge: 'Adopt Free',
  sold: 0
},
{
  id: 'prod-011',
  name: 'Kong Classic Dog Toy — Medium',
  category: 'Toys' as Category,
  price: 695,
  rating: 4.8,
  reviews: 201,
  seller: 'PawsPlay PH',
  verified: false,
  location: 'Mandaluyong',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d1cd2b17-1776878926013.png",
  imageAlt: 'Red Kong rubber dog toy on wooden floor',
  badge: null,
  sold: 1567
},
{
  id: 'prod-012',
  name: 'Premium Pet Grooming Glove — Deshedding',
  category: 'Grooming' as Category,
  price: 380,
  rating: 4.5,
  reviews: 119,
  seller: 'Groom&Bloom',
  verified: false,
  location: 'Pasig City',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1fc5bc703-1769368926764.png",
  imageAlt: 'Blue grooming glove with rubber nubs held up against white background',
  badge: null,
  sold: 432
}];


const categories: Category[] = ['All', 'Food', 'Accessories', 'Health', 'Grooming', 'Toys', 'Adoption'];

const sortOptions = [
{ value: 'featured', label: 'Featured' },
{ value: 'price-asc', label: 'Price: Low to High' },
{ value: 'price-desc', label: 'Price: High to Low' },
{ value: 'rating', label: 'Highest Rated' },
{ value: 'sold', label: 'Most Sold' }];


export default function MarketplaceShell() {
  const [activeCategory, setActiveCategory] = useState<Category>('All');
  const [sortBy, setSortBy] = useState('featured');
  const [search, setSearch] = useState('');
  const [cartCount, setCartCount] = useState(0);
  const [savedIds, setSavedIds] = useState<Set<string>>(new Set());
  const [verifiedOnly, setVerifiedOnly] = useState(false);

  const filtered = useMemo(() => {
    let items = allProducts.filter((p) => {
      const matchCat = activeCategory === 'All' || p.category === activeCategory;
      const matchSearch = p.name.toLowerCase().includes(search.toLowerCase()) || p.seller.toLowerCase().includes(search.toLowerCase());
      const matchVerified = !verifiedOnly || p.verified;
      return matchCat && matchSearch && matchVerified;
    });

    switch (sortBy) {
      case 'price-asc':items = [...items].sort((a, b) => a.price - b.price);break;
      case 'price-desc':items = [...items].sort((a, b) => b.price - a.price);break;
      case 'rating':items = [...items].sort((a, b) => b.rating - a.rating);break;
      case 'sold':items = [...items].sort((a, b) => b.sold - a.sold);break;
    }
    return items;
  }, [activeCategory, sortBy, search, verifiedOnly]);

  const toggleSave = (id: string) => {
    setSavedIds((prev) => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });
  };

  return (
    <div className="min-h-screen bg-background">
      {/* Page header */}
      <div className="bg-white border-b border-border sticky top-16 z-30">
        <div className="max-w-screen-2xl mx-auto px-6 lg:px-10 py-4">
          <div className="flex flex-col sm:flex-row sm:items-center gap-4">
            <div className="flex-1">
              <h1 className="text-xl font-extrabold text-foreground">Pet Marketplace</h1>
              <p className="text-xs text-muted-foreground font-medium mt-0.5">
                {filtered.length} items found
              </p>
            </div>
            {/* Search */}
            <div className="relative flex-1 max-w-sm">
              <Icon name="MagnifyingGlassIcon" size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
              <input
                type="text"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder="Search products or sellers..."
                className="input-field pl-9 py-2.5 text-sm"
                aria-label="Search marketplace" />
              
            </div>
            {/* Sort */}
            <select
              value={sortBy}
              onChange={(e) => setSortBy(e.target.value)}
              className="input-field py-2.5 text-sm w-auto cursor-pointer"
              aria-label="Sort products">
              
              {sortOptions.map((opt) =>
              <option key={`sort-${opt.value}`} value={opt.value}>{opt.label}</option>
              )}
            </select>
          </div>
        </div>
      </div>

      <div className="max-w-screen-2xl mx-auto px-6 lg:px-10 py-6">
        <div className="flex gap-6">
          {/* Sidebar filters */}
          <aside className="hidden lg:flex flex-col gap-5 w-56 flex-shrink-0">
            <div className="bg-white rounded-xl border border-border/60 shadow-card p-5">
              <h3 className="text-sm font-bold text-foreground mb-3">Categories</h3>
              <div className="flex flex-col gap-1">
                {categories.map((cat) =>
                <button
                  key={`cat-filter-${cat}`}
                  onClick={() => setActiveCategory(cat)}
                  className={`text-left px-3 py-2 rounded-lg text-sm font-semibold transition-colors ${
                  activeCategory === cat ?
                  'bg-primary-tint text-primary' : 'text-body-text hover:bg-muted'}`
                  }>
                  
                    {cat === 'All' ? '🐾 All Products' :
                  cat === 'Food' ? '🍖 Food & Treats' :
                  cat === 'Accessories' ? '🎀 Accessories' :
                  cat === 'Health' ? '💊 Health & Meds' :
                  cat === 'Grooming' ? '✂️ Grooming' :
                  cat === 'Toys' ? '🎾 Toys & Play' : '🏠 Adoption'}
                  </button>
                )}
              </div>
            </div>

            <div className="bg-white rounded-xl border border-border/60 shadow-card p-5">
              <h3 className="text-sm font-bold text-foreground mb-3">Filters</h3>
              <label className="flex items-center gap-2.5 cursor-pointer">
                <input
                  type="checkbox"
                  checked={verifiedOnly}
                  onChange={(e) => setVerifiedOnly(e.target.checked)}
                  className="w-4 h-4 rounded accent-primary" />
                
                <span className="text-sm text-body-text font-medium">Verified sellers only</span>
              </label>
            </div>

            {/* Adoption center promo */}
            <div className="bg-secondary-tint rounded-xl border border-secondary/20 p-4">
              <div className="flex items-center gap-2 mb-2">
                <span className="text-lg">🏠</span>
                <h4 className="text-sm font-bold text-secondary">Adoption Center</h4>
              </div>
              <p className="text-xs text-body-text font-medium leading-relaxed mb-3">
                Give a rescued pet a loving home. All adoption pets are vaccinated and dewormed.
              </p>
              <button
                onClick={() => setActiveCategory('Adoption')}
                className="btn-secondary text-xs px-4 py-2 w-full justify-center">
                
                View Adoptable Pets
              </button>
            </div>
          </aside>

          {/* Main content */}
          <div className="flex-1 min-w-0">
            {/* Category chips — mobile */}
            <div className="lg:hidden flex gap-2 overflow-x-auto scrollbar-hide pb-3 mb-4">
              {categories.map((cat) =>
              <button
                key={`chip-mob-${cat}`}
                onClick={() => setActiveCategory(cat)}
                className={`chip flex-shrink-0 ${activeCategory === cat ? 'chip-active' : ''}`}>
                
                  {cat}
                </button>
              )}
            </div>

            {/* Active filters */}
            {(activeCategory !== 'All' || verifiedOnly || search) &&
            <div className="flex flex-wrap items-center gap-2 mb-4">
                <span className="text-xs text-muted-foreground font-semibold">Active filters:</span>
                {activeCategory !== 'All' &&
              <span className="flex items-center gap-1 bg-primary-tint text-primary text-xs font-bold px-3 py-1 rounded-full">
                    {activeCategory}
                    <button onClick={() => setActiveCategory('All')} className="hover:text-primary-hover ml-0.5">
                      <Icon name="XMarkIcon" size={12} />
                    </button>
                  </span>
              }
                {verifiedOnly &&
              <span className="flex items-center gap-1 bg-secondary-tint text-secondary text-xs font-bold px-3 py-1 rounded-full">
                    Verified Only
                    <button onClick={() => setVerifiedOnly(false)} className="hover:text-secondary-hover ml-0.5">
                      <Icon name="XMarkIcon" size={12} />
                    </button>
                  </span>
              }
                {search &&
              <span className="flex items-center gap-1 bg-chip-bg text-body-text text-xs font-bold px-3 py-1 rounded-full">
                    "{search}"
                    <button onClick={() => setSearch('')} className="hover:text-foreground ml-0.5">
                      <Icon name="XMarkIcon" size={12} />
                    </button>
                  </span>
              }
              </div>
            }

            {/* Empty state */}
            {filtered.length === 0 &&
            <div className="flex flex-col items-center justify-center py-20 text-center">
                <div className="w-16 h-16 rounded-full bg-muted flex items-center justify-center mb-4">
                  <Icon name="ShoppingBagIcon" size={28} className="text-muted-foreground" />
                </div>
                <h3 className="text-base font-bold text-foreground mb-1">No products found</h3>
                <p className="text-sm text-muted-foreground font-medium max-w-xs">
                  Try adjusting your filters or search terms to find what you're looking for.
                </p>
                <button onClick={() => {setActiveCategory('All');setSearch('');setVerifiedOnly(false);}} className="btn-primary mt-4 text-sm">
                  Clear All Filters
                </button>
              </div>
            }

            {/* Product grid */}
            {filtered.length > 0 &&
            <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-4 lg:gap-5">
                {filtered.map((product) =>
              <div
                key={product.id}
                className="card-hover bg-white rounded-xl overflow-hidden border border-border/60 shadow-card group cursor-pointer">
                
                    {/* Image */}
                    <div className="relative h-[190px] bg-muted overflow-hidden">
                      <AppImage
                    src={product.image}
                    alt={product.imageAlt}
                    fill
                    className="object-cover group-hover:scale-105 transition-transform duration-500" />
                  
                      {/* Save button */}
                      <button
                    onClick={() => toggleSave(product.id)}
                    className="absolute top-2.5 right-2.5 w-8 h-8 glass-card rounded-full flex items-center justify-center border border-white/60 hover:bg-white transition-colors"
                    aria-label={savedIds.has(product.id) ? 'Remove from saved' : 'Save product'}>
                    
                        <Icon
                      name="HeartIcon"
                      size={15}
                      variant={savedIds.has(product.id) ? 'solid' : 'outline'}
                      className={savedIds.has(product.id) ? 'text-brand-red' : 'text-muted-foreground'} />
                    
                      </button>
                      {/* Badge */}
                      {product.badge &&
                  <div className={`absolute bottom-2.5 left-2.5 text-xs font-bold px-2.5 py-1 rounded-full ${
                  product.badge === 'Adopt Free' ? 'bg-secondary-tint text-secondary' :
                  product.badge === 'Bestseller' ? 'bg-accent-tint text-accent-dark' :
                  product.badge === 'Top Rated' ? 'bg-yellow text-navy' : 'bg-primary-tint text-primary'}`
                  }>
                          {product.badge}
                        </div>
                  }
                    </div>

                    {/* Info */}
                    <div className="p-4">
                      {/* Seller */}
                      <div className="flex items-center gap-1.5 mb-2">
                        {product.verified &&
                    <span className="badge-verified text-xs">✓ Verified</span>
                    }
                        <span className="text-xs text-muted-foreground font-medium truncate">{product.seller}</span>
                      </div>

                      {/* Name */}
                      <h3 className="text-sm font-bold text-foreground leading-snug line-clamp-2 mb-2">{product.name}</h3>

                      {/* Rating */}
                      <div className="flex items-center gap-1.5 mb-3">
                        <div className="flex gap-0.5">
                          {[1, 2, 3, 4, 5].map((s) =>
                      <Icon
                        key={`${product.id}-star-${s}`}
                        name="StarIcon"
                        size={11}
                        variant={s <= Math.round(product.rating) ? 'solid' : 'outline'}
                        className={s <= Math.round(product.rating) ? 'text-yellow' : 'text-muted-foreground'} />

                      )}
                        </div>
                        <span className="text-xs text-muted-foreground font-medium">{product.rating} ({product.reviews})</span>
                      </div>

                      {/* Price + Cart */}
                      <div className="flex items-center justify-between">
                        {product.price === 0 ?
                    <span className="text-base font-extrabold text-secondary">Adopt Free</span> :

                    <span className="text-base font-extrabold text-foreground font-tabular">₱{product.price.toLocaleString()}</span>
                    }
                        <button
                      onClick={() => setCartCount((c) => c + 1)}
                      className="w-8 h-8 bg-primary rounded-full flex items-center justify-center hover:bg-primary-hover transition-colors active:scale-95"
                      aria-label={product.price === 0 ? 'Adopt this pet' : 'Add to cart'}>
                      
                          <Icon name={product.price === 0 ? 'HeartIcon' : 'ShoppingCartIcon'} size={15} className="text-white" />
                        </button>
                      </div>

                      {/* Location */}
                      <div className="flex items-center gap-1 mt-2">
                        <Icon name="MapPinIcon" size={11} className="text-muted-foreground" />
                        <span className="text-xs text-muted-foreground font-medium">{product.location}</span>
                        {product.sold > 0 &&
                    <span className="text-xs text-muted-foreground font-medium ml-auto">{product.sold.toLocaleString()} sold</span>
                    }
                      </div>
                    </div>
                  </div>
              )}
              </div>
            }

            {/* Cart indicator toast */}
            {cartCount > 0 &&
            <div className="fixed bottom-20 lg:bottom-6 right-6 bg-primary text-white rounded-full px-5 py-3 shadow-primary-glow flex items-center gap-2 text-sm font-bold fade-in z-50">
                <Icon name="ShoppingCartIcon" size={16} />
                {cartCount} item{cartCount > 1 ? 's' : ''} in cart
              </div>
            }
          </div>
        </div>
      </div>
    </div>);

}